import React from 'react'
import { Dropdown } from 'react-bootstrap'
import { PagerComponent, PageEventArgs } from '@syncfusion/ej2-react-grids'
import './PaginationContainer.css'

export type PaginationContainerProps = {
  totalRecordsCount: number
  pageSize: number
  currentPage: number
  pageSizeOptions?: number[]
  onPageSizeChange: (newPageSize: number) => void
  onPageChange: (args: PageEventArgs) => void
  className?: string
}

const PaginationContainer: React.FC<PaginationContainerProps> = ({
  totalRecordsCount,
  pageSize,
  currentPage,
  pageSizeOptions = [10, 25, 50, 100],
  onPageSizeChange,
  onPageChange,
  className = '',
}) => {
  const handlePageSizeChange = (size: number): void => {
    onPageSizeChange(size)
  }

  return (
    <div className={`pagination-container ${className}`}>
      <Dropdown>
        <Dropdown.Toggle className="viewport-header-dropdown">
          {pageSize} results/page
        </Dropdown.Toggle>

        <Dropdown.Menu>
          {pageSizeOptions.map((size) => (
            <Dropdown.Item
              key={size}
              onClick={() => handlePageSizeChange(size)}
              active={pageSize === size}
            >
              {size} results/page
            </Dropdown.Item>
          ))}
        </Dropdown.Menu>
      </Dropdown>

      <PagerComponent
        totalRecordsCount={totalRecordsCount}
        pageSize={pageSize}
        currentPage={currentPage}
        click={onPageChange}
      />
    </div>
  )
}

export default PaginationContainer
